<div class="wrapper">
  <ng-container
    *ngIf="!data.order.order.paymentComplete && data.order.order.paymentType !== PaymentMethod.Transfer; else paymentState">
    <div class="title">Kies een betaal optie</div>
    <ion-segment [value]="paymentMethod" (ionChange)="segmentChanged($event)" mode="ios">
      <ion-segment-button [value]="PaymentMethod.QrCode" layout="icon-start">
        <ion-icon src="../../assets/icon/qr-code.svg"></ion-icon>
        <ion-label>QR</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="PaymentMethod.Cash" layout="icon-start">
        <ion-icon src="../../assets/icon/cash.svg"></ion-icon>
        <ion-label>Cash</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="PaymentMethod.Card" layout="icon-start">
        <ion-icon src="../../assets/icon/card.svg"></ion-icon>
        <ion-label>Card</ion-label>
      </ion-segment-button>
    </ion-segment>
    <div [ngSwitch]="paymentMethod" class="payment__method">
      <app-qr-code *ngSwitchCase="PaymentMethod.QrCode" [data]="data" />
      <app-cash *ngSwitchCase="PaymentMethod.Cash" [data]="data" />
      <app-card *ngSwitchCase="PaymentMethod.Card" [data]="data" />
    </div>
  </ng-container>

  <ng-template #paymentState>
    <ng-container *ngIf="data.order.order.paymentComplete; else transferState">
      <div class="title title__payment-complete">
        <ng-lottie [options]="options" />
        Deze Bestelling is betaald
      </div>
    </ng-container>
  </ng-template>

  <ng-template #transferState>
    <div class="title title__payment-transfer">Deze bestelling wordt via overschrijving betaald</div>
  </ng-template>

  <div class="action-buttons">
    <ion-button *ngIf="data.order.order.isInDelivery" (click)="endDelivery(data.order)" class="end-delivery">
      Bestelling afleveren
    </ion-button>
  </div>
</div>